<template lang="html">
  <div class="special-index-list" v-if="html_show">
    <p class="info-p"><img :src="$store.state.static_img_url+'mobile/pic/zhuanti.png'"></img> <span>专题Pro</span> <span class="filter" @click="menu_show = true">分类<i class="iconfont">&#xe6d2;</i></span> </p>
    <p class="show-tag" :class="{'is-pay': typeIsFees(select_type_id)}">当前分类：{{theme_type_text}}</p>
    <!-- <div class="scroll-tag" v-if="typeIsFees(select_type_id)">
      <span class="scroll">
        1、此内容需付费，单篇专题付费后，附赠解锁{{theme_type_text2}}所有专题，平台VIP会员免费查看；
        2、本专栏购买成功后一年内有效；
        3、本专栏为虚拟内容服务，一经购买成功概不退款，请您理解；
        4、购买后，可前往电脑端【个人中心-已购产品】查看已购买的专栏；
        5、《{{theme_type_text2}}》内容为动脉橙平台所有。
      </span>
    </div> -->
    <div class="know-tag" v-if="typeIsFees(select_type_id)">
      <p><i class="iconfont">&#xe654;</i>购买须知</p>
      <div  @click="buy_know=true">查看</div>
    </div>
    <ul class="recommend" v-if="select_type_id == ''">
      <li @click="goDetail(i, index)" v-for="(i, index) in recommend_list" :key="i.id">
        <img :src="i.share_logo_path | logo_show">
        <div class="mask">
          <p>
            <!-- <span>人工智能</span>  -->
            <span>{{i.update_time | time_standard}}</span>
            <span v-if="i.latest_content.length > 0">{{i.latest_content[0].title}}</span>
          </p>
          <p>{{i.title}}</p>
        </div>
        <img class="pay-tag" :src="$store.state.static_img_url+'mobile/pic/theme/pay_success_tag.png'" v-if="!is_vip && parseFloat(i.price) > 0 && hasPay(i.type_arr[0]) && typeIsFees(i.type_arr[0])" />
        <img class="pay-tag" :src="$store.state.static_img_url+'mobile/pic/theme/pay_tag.png'" v-if="!is_vip && parseFloat(i.price) > 0 && !hasPay(i.type_arr[0]) && typeIsFees(i.type_arr[0])" />
        <img class="vip-tag" :src="$store.state.static_img_url+'mobile/pic/theme/vip_tag.png'" v-if="is_vip && parseFloat(i.price) > 0 && typeIsFees(i.type_arr[0])" />
      </li>
    </ul>
    <div class="list" :class="{'is-pay': typeIsFees(select_type_id)}">
      <div class="item" v-for="i in theme_list" :key="i.id" @click="goDetail(i, 2)">
        <img :src="i.share_logo_path | logo_show">
        <div>
          <p>{{i.title}}</p>
          <p>{{i.update_time | time_standard}}更新</p>
          <!-- <p>{{i.summary}}</p> -->
          <p v-if="i.latest_content.length > 0">{{i.latest_content[0].title}}</p>
        </div>
        <img class="pay-tag" :src="$store.state.static_img_url+'mobile/pic/theme/pay_success_tag.png'" v-if="!is_vip && parseFloat(i.price) > 0 && hasPay(i.type_arr[0]) && typeIsFees(i.type_arr[0])" />
        <img class="pay-tag" :src="$store.state.static_img_url+'mobile/pic/theme/pay_tag.png'" v-if="!is_vip && parseFloat(i.price) > 0 && !hasPay(i.type_arr[0]) && typeIsFees(i.type_arr[0])" />
        <img class="vip-tag" :src="$store.state.static_img_url+'mobile/pic/theme/vip_tag.png'" v-if="is_vip && parseFloat(i.price) > 0 && typeIsFees(i.type_arr[0])" />
      </div>
    </div>
    <div v-show="is_show_more_button" class="more-button" :class="{ 'loading': button_loading }" @click="changePage">
      <span>{{button_loading ? '正在加载中...':'加载更多'}}</span>
    </div>
    <div class="nothing" v-if="theme_list.length == 0 && select_type_id != ''">
      <img :src="$store.state.static_img_url+'mobile/pic/zanwu.png'">
      <p class="sp1">暂无数据</p>
      <p class="sp2">您可以查看其他分类哦~</p>
    </div>

    <!-- 目录抽屉 -->
    <div class="menu" :class="{'open': menu_show}">
      <div class="one">
        <span>
          专题类别
          <img :src="$store.state.static_img_url+'mobile/pic/border.png'" />
        </span>
      </div>
      <ul class="fa-ul">
        <li class="fa-li" :class="{'selected': select_type_id == ''}" @click="selectItem('')">
          <p>最新</p>
        </li>
        <div v-for="i in theme_type" :key="i.id">
          <!-- <li v-if="i.kids.length == 0" class="fa-li" :class="{'selected': i.id == select_type_id}" @click="selectItem(i.id)">
            <p>{{i.name}}</p>
          </li> -->
          <li v-if="i.kids.length != 0" class="fa-li" :class="{'opened':bold_pid == i.id}" @click="open(i.id)">
            <p>{{i.name}}</p>
            <i class="iconfont" v-if="!showOpen(i.id)">&#xe63b;</i>
            <i class="iconfont" v-if="showOpen(i.id)">&#xe648;</i>
          </li>
          <div v-if="!showOpen(i.id)">
            <li class="ch-li" :class="{'selected': j.id == select_type_id}" v-for="j in i.kids" :key="j.id" @click="selectItem(j.id, 'c')">
              <p>{{j.name}}</p>
            </li>
          </div>
        </div>
      </ul>
    </div>

    <!-- 页面蒙层 -->
    <div :class="{'mask-all': menu_show}" @click="menu_show=false"></div>

    <!-- 购买须知 -->
    <div class="buy-know" v-if="buy_know">
      <div class="pic">
        <p>购买须知</p>
        <p class="content">1、此内容需付费，单篇专题付费后，附赠解锁《{{theme_type_text}}》所有专题，平台VIP会员免费查看；</p>
        <p class="content">2、本专栏购买成功后一年内有效；</p>
        <p class="content">3、本专栏为虚拟内容服务，一经购买成功概不退款，请您理解；</p>
        <p class="content">4、购买后，可从电脑端的【个人中心-已购产品】中查看已购买的专栏；</p>
        <p class="content">5、《{{theme_type_text}}》内容为动脉橙平台所有。</p>
        <div class="button"  @click="buy_know=false">
          我知道了
        </div>
      </div>
      <i class="iconfont" @click="buy_know=false">&#xe65e;</i>
    </div>
    <!-- 页面蒙层 -->
    <div :class="{'mask-all': buy_know}"></div>
  </div>
  <Loading v-else></Loading>
</template>

<script>
import { getMeta, recommendTheme, themeList, addPuv, getUserPayThemeType } from '../service'
import Loading from '@/views/Mobile/components/loading.vue'
import store from '@/store'
import { user_mixin } from 'mobile/js/user_mixin'
export default {
  inject: ['reload'],
  mixins: [user_mixin],
  data() {
    return {
      is_create: false, // 元素是否已经被创建

      recommend_list: [],
      theme_list: [],
      page: 1,
      button_loading: false,
      is_show_more_button: true,

      recommend_finished: false,
      theme_finished: false,

      menu_show: false, // 筛选菜单是否显示
      open_list: [], // 展开列表
      select_type_id: '', // 被选中item
      bold_pid: '', // 被选中的父级
      theme_type_text: '最新',
      theme_type_text2: '最新',

      state_theme_type: [], // 初始的类型数组
      theme_type: [], // 处理后的类型数组

      user_pay_theme_type: [], // 用户已购买专题类型

      buy_know: false // 购买须知
    }
  },
  computed: {
    html_show() { // 页面加载中的显示
      return this.recommend_finished && this.theme_finished
    },
    req_url() {
      return this.$store.state.req_url
    },
    // theme_type() {
    //   if (!this.$store.state.theme_type) {
    //     return []
    //   } else {
    //     let arr = []
    //     for(let i of this.$store.state.theme_type) {
    //       if (i.pid == null) {
    //         i.kids = this.$store.state.theme_type.filter(item => item.pid == i.id)
    //         arr.push(i)
    //       }
    //     }
    //     return arr
    //   }
    // }
  },
  components: {
    Loading
  },
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['theme_type']
      })
      if (res.status == 'success') {
        this.state_theme_type = res.meta.theme_type
        let arr = []
        for(let i of res.meta.theme_type) {
          if (i.pid == null) {
            i.kids = res.meta.theme_type.filter(item => item.pid == i.id)
            arr.push(i)
          }
        }
        this.theme_type = arr
        this.getRecomment()
        if (this.$route.query.active) {
          let temp = this.state_theme_type.find(item => item.id == this.$route.query.active)
          if (temp.pid) {
            this.selectItem(this.$route.query.active, 'c')
            this.open_list.push(temp.pid)
          } else {
            this.selectItem(this.$route.query.active)
          }
        } else {
          this.getList()
        }
        if (this.$store.state.user_key) {
          this.getUserPayThemeType()
        }
        this.addPuv()
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getRecomment() {
      let res = await recommendTheme({
        latest_size:1,
        position_id:2,
        size:3
      },
      (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.recommend_list = res.res
      } else {
        this.$Message.error(res.message)
      }
      if (!this.recommend_finished) {
        this.recommend_finished = true
      }
    },
    async getList() {
      let res = await themeList({page: this.page, theme_type_id: this.select_type_id, only_vip: this.select_type_id?'':0},
      (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.theme_list = [...this.theme_list,...res.res]
        if (res.res.length < 12) {
          this.is_show_more_button = false
        }
      } else {
        this.$Message.error(res.message)
      }
      if (!this.theme_finished) {
        this.theme_finished = true
      }
      this.button_loading = false
    },
    async getUserPayThemeType() { // 获取用户已购专题类型
      let res = await getUserPayThemeType({
        user_key: this.$store.state.user_key
      })
      if (res.status == 'success') {
        this.user_pay_theme_type = res.res
      } else {
        this.$Message.error(res.message)
      }
    },
    async addPuv() { // 统计点击量
      await addPuv({url: window.location.protocol + '//' + window.location.host+ '/mindex' +this.$route.fullPath})
    },
    changePage() { // 翻页
      this.button_loading = true
      this.page = this.page + 1
      this.getList()
    },
    goDetail(row, index) { // 去到详情页
      if (index == 0 || index == 1) {
        _czc.push(['_trackEvent', '手机端专题列表页', '广告位点击（' + (index+1) + '）'])
      } else {
        _czc.push(['_trackEvent', '手机端专题列表页', '专题点击（'+row.title+'）'])
      }
      this.$router.push({name: 'MSpecialDetail', params: { uid: row.uid }})
    },
    open(id) {// 展开的动作
      let index = this.open_list.indexOf(id)
      if (index == -1) {
        this.open_list.push(id)
        _czc.push(['_trackEvent', '手机端专题一级点击', '一级点击（'+this.state_theme_type.find(item => item.id == id).name+'）'])
      } else {
        this.open_list.splice(index, 1)
      }
    },
    showOpen(id) { // 是否展开和收起
      if (this.open_list.indexOf(id) == -1) {
        return true
      } else {
        return false
      }
    },
    selectItem(id, c) { // 点击选项
      this.select_type_id = id
      this.page = 1
      let temp = this.state_theme_type.find(item => item.id == id)
      if (temp.price > 0) {
        this.buy_know = true
      } else {
        this.buy_know = false
      }
      _czc.push(['_trackEvent', '手机端专题二级点击', '二级点击（'+(temp ? temp.name : '最新')+'）'])
      this.theme_type_text =  (temp ? temp.name : '最新')
      this.theme_type_text2 =  (temp ? temp.name : '最新')
      if (c) {
        this.bold_pid = temp.pid
        this.theme_type_text = this.state_theme_type.find(item => item.id == temp.pid).name+' / '+temp.name
      } else {
        this.bold_pid = ''
      }
      this.menu_show = false
      this.theme_finished = false
      this.theme_list = []
      this.getList()
      if(id === ''){
        this.$router.push({ name: 'MSpecialList', query:{}})
      }else {
        this.$router.push({ name: 'MSpecialList', query:{ active: id} })
      }
    },
    hasPay(theme_type_id) { // 用户是否购买当前类型
      let i = this.user_pay_theme_type.find(item => item.theme_type_id == theme_type_id)
      if (i) {
        return true
      } else {
        return false
      }
    },
    typeIsFees(theme_type_id) { // 类型是不是不收钱的
      let i = this.state_theme_type.find(item => item.id == theme_type_id)
      if (i) {
        return parseFloat(i.price) > 0
      } else {
        return false
      }
    }
  },
  created() {
    this.getMeta()
  }
}
</script>
<style lang="stylus" scoped>
@keyframes marquee {
  0% {
    transform: translateX(0px);
    -webkit-transform: translateX(0px);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}
ellipsis()
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
.special-index-list
  padding: .4rem 0;
  .info-p
    margin-bottom: .28rem;
    font-size: .40rem;
    color: #333;
    padding: 0 .28rem;
    img
      width: .4rem;
      height: .4rem;
      margin-right: .2rem;
      margin-top: -.06rem;
    span
      font-weight: bold;
    .filter
      float: right;
      font-size: .28rem;
      color: #666;
      font-weight: normal;
      margin-top: .14rem;
      i
        color: #BBBBBB;
        margin-left: .08rem;
        font-size: .28rem;
  .show-tag
    font-size: .24rem;
    color: #999999;
    margin-bottom: .28rem;
    padding: 0 .28rem;
    &.is-pay
      margin-bottom: .4rem;
  .know-tag
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .28rem;
    p
      font-size: .28rem;
      color: #282828;
      font-weight: bold;
      i
        font-weight: normal;
        color: rgba(250, 122, 80, 1);
        margin-right: .14rem;
    div
      font-size: .24rem;
      color: #FA5A00;
  .scroll-tag
    width: 100%;
    background: #FFF3E9;
    color: #FA5A00;
    font-size: .24rem;
    padding: .16rem;
    height: .56rem;
    position: relative;
		overflow: hidden;
    // position: relative;
    span.scroll
      position: absolute;
      animation: 60s marquee linear infinite normal;
      top: .16rem;
      left: 0;
      white-space: nowrap;
  .recommend
    padding: 0 .28rem
    li
      position: relative;
      border-radius: .08rem;
      box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
      overflow: hidden;
      margin-bottom: .28rem
      img
        width: 100%;
        height: 4.35rem;
        display: block;
      .mask
        height: 2.2rem;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column-reverse;
        padding: 0 .4rem .28rem .4rem;
        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 150%);
        >p:nth-child(1)
          font-size: .24rem;
          color: #ccc;
          -webkit-line-clamp: 2;
          ellipsis()
          max-height: .64rem;
          line-height: .32rem;
          span:nth-child(1)
            color: #FA5A00
          span+span
            margin-left: .18rem;
            padding-left: .18rem;
            border-left: 1px solid #E9E9E9
        >p:nth-child(2)
          font-size: .30rem;
          color: #FFFFFF;
          line-height: .38rem;
          max-height: .76rem;
          -webkit-line-clamp: 2;
          font-weight: 600;
          margin-bottom: .1rem;
          ellipsis()
  .list
    padding: 0 .28rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: .28rem .28rem;
    gap: .28rem .28rem;
    &.is-pay
      margin-top: .2rem
    .item
      width: 100%;
      overflow: hidden;
      border-radius: .08rem;
      background: #FFFFFF;
      box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
      position: relative;
      img
        width: 100%;
        height: 1.98rem;
      >div
        p:nth-child(1)
          margin: .18rem 0;
          padding: 0 .2rem;
          ellipsis()
          font-size: .3rem;
          color: #333333;
          line-height: .38rem;
          height: .76rem;
          -webkit-line-clamp: 2;
          font-weight: 600;
        p:nth-child(2)
          font-size: .24rem;
          color: #ffffff;
          background:linear-gradient(270deg,#FFefe1,#FA5A00);
          padding: .02rem .2rem;
        p:nth-child(3)
          margin: .18rem 0;
          padding: 0 .2rem;
          ellipsis()
          font-size: .24rem;
          color: #666666;
          line-height: .32rem;
          height: .64rem;
          -webkit-line-clamp: 2;
          font-weight: 600;
  .nothing
    margin-top: 1.4rem;
    text-align: center;
    img
      width: 2.13rem;
      height: 1.55rem;
    .sp1
      font-size: .4rem;
      color: #333;
      margin: .4rem 0 .3rem 0;
    .sp2
      font-size: .32rem;
      color: #999
  .more-button
    margin-top: .48rem;
    background: #FFFAF6;
    border-radius: .08rem;
    text-align: center;
    color: #FA5A00;
    font-size: .3rem;
    padding: .24rem 0
  .menu
      width: 4.4rem;
      height: 100%;
      transform: translate(4.4rem);
      position:fixed;
      top: 0;
      right: 0;
      z-index: 1003;
      background: #fff;
      transition: all .3s;
      &.open
        transform: translate(0);
      .one
        padding: 0 .6rem;
        border-bottom: 1px solid #E9E9E9;
        font-size: .36rem;
        color: #333333;
        font-weight: 600;
        height: 1rem;
        span
          display: inline-block;
          padding: .32rem 0 .32rem;
          position: relative;
          img
            position: absolute;
            bottom: 0;
            left: 0;
            height: .06rem;
            width: .72rem;
            display: block;
      .fa-ul
        overflow-y: scroll;
        height: calc(100% - 1rem);
        padding: .2rem 0 .4rem;
        li
          display: flex;
          justify-content: space-between;
          align-items: center;
          min-height: .88rem;
          color: #666;
          &.selected
            color: #FA5A00;
            font-weight: bold;
            background: #FFFAF6;
          p
            line-height: .36rem;
            font-size: .28rem;
          i
            margin-left: .2rem;
            font-size: .24rem;
            color: #CCCCCC;
        li.fa-li
          padding: .26rem .4rem .26rem .6rem
          &.opened
            p
              font-weight: bold;
              color: #333333;
            i
              color: #333333
        li.ch-li
          padding: .26rem .9rem;
  .mask-all
    position:fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.50);
    z-index: 1002;
.pay-tag,.vip-tag
  width: .9rem !important;
  height: .3rem !important;
  position: absolute;
  top: .2rem;
  right: 0;
.buy-know
  position:fixed;
  top: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 5.8rem;
  // background-color: #ffffff
  background-image: url('~mobile/pic/know.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  z-index: 1003;
  .pic
    padding: .58rem .72rem .94rem;
    p:nth-child(1)
      color: #333333
      font-size: .4rem
      text-align: center;
      font-weight: bold;
      margin-bottom: .24rem;
    p.content
      color: #666666
      font-size: .24rem
      line-height: .36rem
    p.content+p.content
      margin-top: .06rem
    .button
      width: 3.2rem;
      height: .76rem;
      border-radius: .38rem;
      text-align: center;
      margin: .5rem auto 0;
      background: #FA5A00;
      color: #ffffff
      font-size: .32rem;
      line-height: .76rem
  >i
    font-size: .52rem;
    margin: .5rem auto 0;
    color: #ffffff;
    display: block;
    text-align: center;
</style>
